import styled from 'styled-components';
import { jdContentTypography } from '../../theme/jdContentTypography';

// ── Page-level wrapper ────────────────────────────────────────────────────────
// NOTE: The previous local `TooltipWrapperStyled` was removed and replaced by
// the canonical `TooltipTriggerStyled` exported from `uiCore` (ADR-007 / REQ-442).
// Consumers should import it as:
//   import { TooltipTriggerStyled } from 'uiCore';

export const DangerIconStyled = styled.span`
  svg path {
    fill: ${p => p.theme?.colors?.danger ?? '#DC2626'} !important;
  }
`;

export const LayoutWrapperStyled = styled.div`
  background-color: ${p => p.theme?.colors?.white ?? '#ffffff'};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

// ── Job title + metadata block ────────────────────────────────────────────────

export const TitleBlockStyled = styled.div`
  padding: 12px 16px 4px;
   .ant-typography {
    margin: 0; 
  }
`;

// ── Grey outer padding + white card ──────────────────────────────────────────

export const PageWrapperStyled = styled.div`
  padding: 12px 16px 0;
  background-color: ${p => p.theme?.colors?.light ?? '#F7F7F7'};
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const WhiteContainerStyled = styled.div`
  background-color: ${p => p.theme?.colors?.white ?? '#ffffff'};
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 8px;
  
  ${({ $isFullscreen }) =>
    $isFullscreen &&
    `
    position: fixed;
    top: 92px;
    left: 112px;
    right: 12px;
    bottom: 12px;
    z-index: 1000;
    margin: 0;
  `}
`;

// ── Grey header bar inside the white card ─────────────────────────────────────

export const HeaderSectionStyled = styled.div`
  background-color: ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  border-bottom: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const VersionBlockStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

// Left column of the grey header bar: stacks the "Edit JD" heading (edit mode
// only) above the version selector + metadata, mirroring the Revision Mode header.
export const HeaderLeftStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EditModeHeadingStyled = styled.h5`
  font-weight: bold;
  margin: 0;
`;

// ── Scrollable JD content ─────────────────────────────────────────────────────

export const ScrollableContentStyled = styled.div`
  ${p => p.$isFullscreen
    ? `
      flex: 1;
      overflow-y: auto;
    `
    : `
      height: calc(100vh - 400px);
      overflow-y: auto;
    `
  }
  text-align: start;
  padding: 30px;
  ${jdContentTypography}
`;

// ── Disclaimer ────────────────────────────────────────────────────────────────

export const DisclaimerStyled = styled.div`
  font-style: italic;
  text-align: left;
  padding: 16px 28px;
  color: ${p => p.theme?.colors?.gray ?? '#565E70'};
`;

// ── Blurred JD + free-trial popup ────────────────────────────────────────────

export const BlurredContentStyled = styled.div`
  filter: ${p => (p.$blurred ? 'blur(6px)' : 'none')};
  pointer-events: ${p => (p.$blurred ? 'none' : 'auto')};
`;

export const FreeTrialPopupStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${p => p.theme?.colors?.white ?? '#ffffff'};
  border: 1px solid ${p => p.theme?.colors?.border ?? '#D8DAE5'};
  border-radius: 8px;
  padding: 24px 28px;
  max-width: 440px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 10;
`;

// ── Status badge ──────────────────────────────────────────────────────────────

export const StatusBadgeWrapperStyled = styled.span`
  margin-right: 20px;
  color: ${p => p.theme?.colors?.danger ?? '#a13d3d'};
  font-weight: 500; 
`;


// ── Edit mode wrapper ─────────────────────────────────────────────────────────

export const EditModeWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  ${p => p.$isFullscreen
    ? `
      flex: 1;
      overflow: hidden;
    `
    : `
      height: calc(80vh - 280px);
      overflow: hidden;
    `
  }
`;

/* Scrollable area that contains CoreMarkdownEditor — scroll stays inside this
   div, NOT the whole body */
export const ScrollAreaStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px;
`;

// ── Coming soon placeholder ───────────────────────────────────────────────────

export const ComingSoonStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
`;
// select wrapper
export const SbSelectWrapper = styled.div`
  padding-bottom: 2px;
  display: block;
`;

export const SubViewTitleStyled = styled.h2`
  margin: 0 0 12px;
  padding-left: 24px;
  font-size: 20px;
  font-weight: 600;
  color: ${p => p.theme.colors.text};
`;

export const TabWrapper = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

//pagespinner 
export const PageSpinnerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const JdSpinnerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 200px;
`;